import { IProfileSettingsOptions } from "@opengov/components-nav-bar";

export type User = {
  id: string | number;
  uuid: string;
  first_name?: string;
  last_name?: string;
  avatar?: string;
  role?: string;
};

export type GetProfileSettingsOptionsParams = {
  entitySubdomain: string;
  user: User;
  handleSignOut: () => void;
};

export const getProfileSettingsOptions = ({
  entitySubdomain,
  user,
  handleSignOut,
}: GetProfileSettingsOptionsParams): IProfileSettingsOptions => {
  const { id, first_name, last_name, avatar } = user;
  const initials = first_name && last_name ? `${first_name[0]}${last_name[0]}` : "";
  return {
    profileImgUrl: avatar,
    placeHolderInitials: initials,
    updateProfileUrl: `/access/${entitySubdomain}/users/${id}`,
    handleSignOut,
  };
};
